import React from 'react'
import Input from './Input'
import IconButton from './IconButton'

function ContactForm({ redLabelShown = true }) {
    return (
        <div className='bg-white rounded-[10px] p-5 max-w-[500px] mx-auto'>      
            {redLabelShown && (
                <div className='bg-primary rounded-full rounded-bl-none py-2 pe-5 ps-12 -ml-10 w-min mb-4'>
                    <span className='text-white font-bold lg:text-2xl'>24/7&nbsp;Emergancy&nbsp;Service</span>
                </div>
            )}

            <div className={`grid grid-cols-2 gap-4 ${!redLabelShown && 'py-4'}`}>
                <div className='col-span-2'>
                    <Input label={'Enter your name'} placeholder='John Smith' />
                </div>
                <Input label={'Email address'} placeholder='jsmaith@email.com' type='email' />

                <Input label={'Contact no.'} placeholder='41 79123 4567' />
                
                <div className='col-span-2'>
                    <Input label={'Quick problem description?'} placeholder='I need help for ..' isTextArea />
                </div>
                <div className='col-span-2'>
                    <IconButton className="w-full py-3">
                        Request Assistance
                    </IconButton>
                </div>
            </div>
        </div>
    )
}

export default ContactForm